import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Contacts({ color = 'icon.primary', fill = 'transparent', ...props }) {
  return (
    <IconBase viewBox='0 0 22 22' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.8194 21.0004H2.85285C1.82917 21.0004 1 20.1712 1 19.1476V6.18097C1 5.15729
         1.82917 4.32812 2.85285 4.32812H15.8206C16.8431 4.32812 17.6723 5.15729 17.6723
          6.18097V19.1487C17.6723 20.1712 16.8431 21.0004 15.8194 21.0004Z'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M11.2989 8.96246C12.3837 10.0473 12.3837 11.8068 11.2989 12.8927C10.2141 13.9775
         8.45463 13.9775 7.36871 12.8927C6.28279 11.8079 6.2839 10.0484 7.36871 8.96246C8.45352
          7.87654 10.213 7.87765 11.2989 8.96246'
        stroke={color}
        fill='transparent'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M14.3354 18.1516C14.1898 17.7859 13.9642 17.4569 13.6752 17.1891V17.1891C13.1872 16.7356
         12.5481 16.4844 11.8812 16.4844C10.7698 16.4844 7.89768 16.4844 6.78619 16.4844C6.1193
          16.4844 5.48131 16.7367 4.99225 17.1891V17.1891C4.70327 17.4569 4.47764 17.7859 4.33203 18.1516'
        stroke={color}
        fill='transparent'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M4.33203 4.33446V2.85285C4.33203 1.82917 5.1612 1 6.18488 1H19.1526C20.1751 1 21.0043
         1.82917 21.0043 2.85285V15.8206C21.0043 16.8431 20.1751 17.6723 19.1515 17.6723H17.6699'
        stroke={color}
        fill='transparent'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

Contacts.propTypes = {
  fill: PropTypes.string,
  color: PropTypes.string,
}

export default Contacts
